export default "__VITE_ASSET__7396f870__"